module.exports = __webpack_public_path__ + "static/media/fbfbanner.2eada6c6.svg";